import { useSearchParams } from 'react-router-dom';
import TaskManagement from '../TaskManagement';
import useManageTasks from '../TaskManagement/useManageTasks';
import './Backlog.scss';
import { WorkspaceView } from '../../types/WorkspaceView';

/**
 * This assumes an actual SpaceID (a number in our DB) is passed along to the component as a prop.
 * @param spaceId // Loaded from the URL
 * @param headerControls
 * @constructor
 */
const Backlog = ({
  activeView,
  headerControls = true,
  handleEditEstimationSettings,
  onImportClick,
}: {
  activeView: WorkspaceView;
  headerControls: boolean;
  handleEditEstimationSettings: () => void;
  onImportClick?: () => void;
}) => {
  // SpaceId is pulled from URL

  const tasksManager = useManageTasks(activeView);
  const {
    actualSpaceId,
    spaceId,
    tableDataLoading,
    usersWithAccessToSpace,
    dataSource,
    setDataSource,
    epics,
    epicIds,
    onDragStart,
    onDragEnd,
    activeEpic,
    sensors,
    taskMenuProps,
  } = tasksManager;

  return (
    <TaskManagement
      actualSpaceId={actualSpaceId}
      spaceId={spaceId}
      tableDataLoading={tableDataLoading}
      usersWithAccessToSpace={usersWithAccessToSpace}
      dataSource={dataSource}
      setDataSource={setDataSource}
      epics={epics}
      epicIds={epicIds}
      onDragStart={onDragStart}
      onDragEnd={onDragEnd}
      activeEpic={activeEpic}
      sensors={sensors}
      taskMenuProps={taskMenuProps}
      activeSprint={undefined}
      activeView={activeView}
      handleEditEstimationSettings={handleEditEstimationSettings}
      onImportClick={onImportClick}
    />
  );
};

export default Backlog;
